import React, { useEffect } from "react";
import "./SplashLoader.css";
import splashVideo from "../Assets/videos/loaderold.mp4"; // Replace with actual path

const SplashLoader = ({ onEnd }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onEnd();
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, [onEnd]);

  return (
    <div className="loader-container splash">
      <video autoPlay muted playsInline className="splash-video">
        <source src={splashVideo} type="video/mp4" />
      </video>
    </div>
  );
};

export default SplashLoader;
